/**
 * Created by anna on 07/08/2017.
 */
import _ from 'lodash';

export const getReview = state => state.reviews.random;

export const getReviews = state => _.values(_.get(state, 'reviews.reviews'));
